let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g7pmM")).then(() => parcelRequire('fe39K'));